import { useEffect } from 'react';

import { useCartStorage } from '../hooks/useCartStorage';
import { useUserShopCarts } from './useUserShopCarts';

/**
 *
 * Cart Provider provides overall cart management outside of the react render tree
 *
 * Whenever a cart is not in the initialized state, it will be removed from local storage
 *
 */
const CartProvider = () => {
  const { removeCart, getCartsByStore } = useCartStorage();
  const { carts, responses } = useUserShopCarts();

  useEffect(() => {
    const invalidCarts = carts.filter((cart) => cart?.status !== 'initialized');
    if (invalidCarts.length > 0) {
      invalidCarts.forEach((cart) => cart && removeCart(cart.uuid));
    }

    /** Whenever carts update, run a check to see if any cart responses errored, if they did remove them from local storage*/
    const handleErroredCart = () => {
      // Cart responses that errored
      const erroredCards = responses.filter((response) => response.error);
      if (!erroredCards.length) return;

      // Cart Ids that are valid responses
      const validCartIds = carts.map((cart) => cart && cart.uuid).filter(Boolean);

      // All carts from local storage
      const cartsByStore = getCartsByStore();

      // Cart Id's that are in storage but not in the validCartIds
      const cartsIdsNotInCartData = cartsByStore
        .filter((cart) => !validCartIds.includes(cart.cart.cartId))
        .map((cart) => cart.cart.cartId);

      if (cartsIdsNotInCartData.length > 0) {
        cartsIdsNotInCartData.forEach((cartId) => removeCart(cartId));
      }
    };

    handleErroredCart();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [carts, responses]);
  return null;
};
export { CartProvider };
